module.exports = __webpack_public_path__ + "static/img/cjzh-companyStructure.70d466e1.png";